import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronDown} from '@fortawesome/free-solid-svg-icons';
import React, {useState, useEffect, useContext} from 'react';
import { ContextProcessor } from '../../partials/Context';
import getCookie from '../../partials/cookie';
import {Errors} from '../../partials/Partials';

function ServicesNavigation() {
    const {home_display_number} = useContext(ContextProcessor) || '';
    const [uuid, setUUID] = useState(null);
    const [errors, setErrors] = useState([])
    const path = window.location.pathname;
    const category = path.slice(1, path.length - 1).split('/')[1]
    var csrftoken = getCookie('csrftoken');

    useEffect(() => {
        fetch('/api/analytics/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                referer: document.referrer
            })

        }).then(res => {
            if (res.ok) {
                res.json().then(data => {
                    const {uuid} = data || null;
                    setUUID(uuid)
                })
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const services = [
        {
            title: <p className="service-title">Rozmowa telefoniczna z doświadczonym prawnikiem</p>,
            subtitle: 'Prawnik zadzwoni na podany przez Ciebie numer telefonu już w ciągu 5-15 minut. Bądź w zasięgu telefonu! Możesz wykorzystać do 15 minut rozmowy.',
            price: 'Płatne 49zł',
            description: <p className="service-description"><b>Pilnie potrzebuję pomocy prawnej</b>, chcę rozwiązać mój problem jak najszybciej. Chcę się skonsultować z prawnikiem teraz.</p>,
            img: '/media/img/platna.png',
            href: `/konsultacja-telefoniczna/${category}/formularz-zgloszenia/`,
            banner_type: 3
        },
        {
            title: <p className="service-title">Zadaj bezpłatne pytanie lub poproś o wycenę</p>,
            subtitle: 'Otrzymasz krótką, nieodpłatną odpowiedź, która pozwoli Ci zdecydować czy Twój problem wymaga dalszych konsultacji prawniczych.',
            price: 'Bezpłatne',
            description: <p className="service-description">Mam problem prawny, ale <b>nie jest to pilna potrzeba</b>. Chcę się zorientować w moich prawach. Mogę poczekać na odpowiedź.</p>,
            img: '/media/img/bezplatne_pytanie.png',
            href: `/zapytaj-prawnika/kategoria/${category}/`,
            banner_type: 1
        },
        {
            title: <p className="service-title">Bezpłatna rozmowa telefoniczna <span className="highlight">w sprawie sądowej</span></p>,
            subtitle: 'Aby skorzystać z bezpłatnej konsultacji, wybierz kategorię i rodzaj sprawy sądowej Możesz wykorzystać do 15 minut rozmowy z prawnikiem.',
            price: 'Bezpłatne',
            description: <p className="service-description"><b>Mam sprawę w sądzie</b>, otrzymałem wezwanie z policji, prokuratury, sądu. Zostałem aresztowany/zatrzymany.</p>,
            img: '/media/img/bezplatna_rozmowa.png',
            href: `/bezplatna-konsultacja-telefoniczna/${category}/formularz-zgloszenia/`,
            banner_type: 2
        }
    ]
    let list = services.map((service, index) => {
        const {description, price, img, title, subtitle, href, banner_type} = service || ''
        return <div className="service" key={index}>
            {description}
            <FontAwesomeIcon icon={faChevronDown} />
            <a href={href} onClick={(e)=>chooseForm(e, href, banner_type)} className="service-box" >
                <div style={{backgroundColor: `${index > 0 ? '#145ca4': '#faba1d'}`, color: `${index > 0 ? '#fff': '#000' }`}} className="price">{price}</div>
                <div className="service-box-content">
                    <div className="image-box">
                        <img src={img} alt=""/>
                    </div>
                    {title}
                    <p className="service-subtitle">{subtitle}</p>
                    <button className="btn btn-primary">Wybierz</button>
                </div>
            </a>
        </div>
    })

    const chooseForm = (e, href, banner_type) => {
        e.preventDefault();
        fetch('/api/analytics/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                uuid: uuid,
                banner_type: banner_type
            })

        }).then(res => {
            if (res.ok) {
                setErrors([])
                window.location.pathname = href
            } else {
                setErrors(['Nie udało się wybrać usługi'])
            }
        })
    }

  return (
    <div id="services-navigation">
        <p className="header"><b>{home_display_number}</b> osób znalazło już pomoc prawną</p>
        <div className="title-header">Jak możemy Ci pomóc?</div>
        <p className="description">Wybierz interesującą Cię usługę w zależności od Twojej aktualnej potrzeby:</p>
        <div className="services">
            {list}
        </div>
        <Errors errors={errors} />
    </div>
  )
}

export default ServicesNavigation